import React, { FC } from 'react'
import { Col } from 'react-bootstrap'

const Loading: FC<{ isLoading: boolean; wrapDiv?: boolean }> = ({ isLoading, wrapDiv = false, children }) => {
  return <>{isLoading ? wrapDiv ? <Col>{getLoading()}</Col> : getLoading() : <>{children}</>}</>
}

export default Loading
function getLoading() {
  return (
    <div className=' h-100 w-100'>
      <div id='loading-circle'>
        <div className='loader'>
          <div className='loader'>
            <div className='loader'>
              <div className='loader'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
